export default "__VITE_ASSET__Ct$g4$Kq__"